import { bizmatesApi } from '@/utils/bizmatesApi';
import logger from '@/modules/Logger';

export const GetMaterialTokenService = {
   msb: async () => {
    logger.debug(`[Materials][TOKEN] No need to fetch material token on canary users`, {
      operation: 'materials:get_token'
    });
  },

  legacy: async (success, error) => {
    logger.debug(`[Materials][TOKEN] Fetching Material token from legacy endpoint`, {
      operation: 'materials:get_token'
    });
    
    await bizmatesApi.get('lessonmaterials/token', {}, response => {
        success(response);
    }, () => {
        logger.error(`[Materials][TOKEN] Error fetching Material token from legacy endpoint`, {
            error: error.message,
            operation: 'materials:get_token'
        });

        error();
    });
  }
};

GetMaterialTokenService.mbti = GetMaterialTokenService.legacy;
